export const STORE_USER = "store_user";
export const USER_SIGNED_OUT = "user_signed_out";
export const USER_EXPIRED = "user_expired";
export const STORE_USER_ERROR = "store_user_error";
export const LOADING_USER = "loading_user";
export const RECEIVED_SESSION_IDLE_MINUTES = "request_session_idle_minutes";
export const SILENT_RENEW_ERROR = "SILENT_RENEW_ERROR";
export const SIGN_IN_PAGE_LOADED="SIGN_IN_PAGE_LOADED";
export const SIGN_OUT="SIGN_OUT";